// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import Contributor from './Contributor';

const Wrap = styled.div`
  position: relative;
  white-space: nowrap;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform-style: preserve-3d;
  margin: 1em 0;
`;

const StyledContributor = styled(Contributor)`
  float: left;
  margin: 0 1em;
  width: 30%;
  min-width: 110px;
`;

type ContributorType = {
  nickname: string;
  avatarPath: string;
  date: string;
  amount: string;
};

type GridsContributorsProps = {
  className?: string;
  contributors: Array<ContributorType>;
};

const GridsContributors = ({ className, contributors }: GridsContributorsProps) => {
  return (
    <Wrap className={className}>
      {contributors.map(({ nickname, avatarPath, date, amount }) => (
        <StyledContributor
          key={`${nickname}${date}`}
          nickname={nickname}
          avatarPath={avatarPath}
          date={date}
          amount={amount}
        />
      ))}
    </Wrap>
  );
};

export default GridsContributors;
